import { axiosApi } from "../../../api/dbAxios";

export const fetchDefaultFilterData = async (
  additionalParams?: Record<string, any>,
) => {
  try {
    const params = new URLSearchParams();
    params.append("only_filters", "true");

    if (additionalParams && typeof additionalParams === "object") {
      Object.entries(additionalParams).forEach(([key, value]) => {
        if (Array.isArray(value)) {
          value.forEach((val) => params.append(key, String(val)));
        } else if (value !== undefined && value !== null) {
          params.append(key, String(value));
        }
      });
    }

    const response = await axiosApi.get(`/items/`, { params });
    return response.data.filters;
  } catch (error) {
    console.error("Error fetching item list:", error);
    return [];
  }
};
